export const modal = {
    state: {
        modalIsPending: false,
        active: false,
        action: {
            confirm: null,
            discard: null
        },
        button: {
            confirm: null,
            discard: null
        },
        content: {
            title: null,
            content: null,
            select: null
        }
    },
    mutations: {
        SHOW_MODAL(state, payload) {
            state.modalIsPending = false
            state.active = true
            state.content = payload.content
            state.action = payload.action
            state.button = payload.button
        },
        HIDE_MODAL(state) {
            state.active = false
        },
        PENDING_MODAL(state, payload) {
            state.modalIsPending = payload
        }
    },
    actions: {
        showModal({ commit }, payload) {
            commit('SHOW_MODAL', payload)
        },
        hideModal({ commit }) {
            commit('HIDE_MODAL')
        },
        pendingModal({ commit }, payload) {
            commit('PENDING_MODAL', payload)
        }
    },
    getters: {
        modalActive: (state) => {
            return state.active
        },
        modalContent: (state) => {
            return state.content
        },
        modalAction: (state) => {
            return state.action
        },
        modalButton: (state) => {
            return state.button
        },
        modalIsPending: (state) => {
            return state.modalIsPending
        },
    }
}
